import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronLargeLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconChevronLargeLeft"><Path fillRule="evenodd" clipRule="evenodd" d="M14.6331 2.10546C14.9892 2.31716 15.1062 2.77739 14.8945 3.13342L10.0022 11.3613C9.76813 11.755 9.76813 12.2453 10.0022 12.639L14.8945 20.8668C15.1062 21.2228 14.9892 21.6831 14.6331 21.8948C14.2771 22.1065 13.8169 21.9895 13.6052 21.6334L8.71294 13.4056C8.1979 12.5394 8.1979 11.4609 8.71293 10.5947L13.6052 2.36681C13.8169 2.01078 14.2771 1.89377 14.6331 2.10546Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronLargeLeft;
